import { EsclationStatus } from "../../../types/services.type";
import { Box, Card, Typography } from "@mui/material";
import { CircleSharp } from "@mui/icons-material";

export default function EscalationStatusMessage({
  data,
}: {
  data: EsclationStatus | null;
}) {
  return (
    <>
      <Card variant="outlined">
        <Box p={1} display={"flex"} gap={1} alignItems={"center"}>
          <Box>
            <CircleSharp
              className="relative top-0 left-0"
              sx={{ fontSize: "10px" }}
              color="success"
            />
            <CircleSharp
              className="relative top-0 left-0 animate-ping"
              sx={{ fontSize: "14px", ml: "-12px" }}
              color="success"
            />
          </Box>
          <Box>
            <Typography variant="body2">Request is escalated.</Typography>
            <Typography variant="caption">
              Reason: <span className='font-bold'>{data?.escalated_reasons}</span>.
            </Typography>
          </Box>
        </Box>
      </Card>
    </>
  );
}
